import * as R from 'ramda'
import { wapprunnerStart, wapprunnerRemove } from 'weblite-web-wapprunner'
import { Meta } from '@weblite-wapps/protocol'
import {
  WAPP_COMMUNICATE_CORE_INITIALIZE_WAPP_DATA,
  WAPP_COMMUNICATE_CORE_API_INITIATED,
  WAPP_COMMUNICATE_CORE_LOADED,
  WAPP_COMMUNICATE_CORE_START,
  WAPP_COMMUNICATE_CORE_CLOSE,
  wappCommunicateCoreInitializeWappData,
} from '@weblite/wapp-communication-action/core'
import {
  wappCommunicateHookWappWillStart,
  wappCommunicateHookWappDidStart,
} from '@weblite/wapp-communication-action/hook'
import { sendOldActionToWapp } from '$logic/wapp-communication/wapp-communication.publish'
import { getWappInput } from '../helper/wapps.helper'
import { getWis } from '$logic/wises'
import { wappSub } from '$func/subscription'

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_LOADED,
  ({ meta }) => {
    // wapprunnerSetCoreLoaded(meta)
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_API_INITIATED,
  ({ meta }) => {
    sendOldActionToWapp(
      wappCommunicateHookWappWillStart({ mode: meta.mode }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_INITIALIZE_WAPP_DATA,
  async ({ meta }) => {
    const { wisId, wappSessionId } = meta
    const wis = await getWis(wisId)

    const wisCreators = wis ? [wis.creator] : []
    const input = await getWappInput(wappSessionId, wisId)

    sendOldActionToWapp(
      wappCommunicateCoreInitializeWappData({
        admins: wisCreators,
        input,
      }),
      meta,
    )
  },
  true,
)

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_START,
  ({ meta }) => {
    wapprunnerStart((meta as Meta).wappSessionId)
    sendOldActionToWapp(
      wappCommunicateHookWappDidStart({ mode: meta.mode }),
      meta,
    )
  },
  true,
)

// wappSub.subscribe(
//   WAPP_COMMUNICATE_CORE_RESTART,
//   ({ meta }) => wapprunnerRestart(meta),
//   true,
// )

// wappSub.subscribe(
//   WAPP_COMMUNICATE_CORE_THROW_ERROR,
//   ({ payload: { error }, meta }) => wapprunnerError(error)(meta),
//   true,
// )

wappSub.subscribe(
  WAPP_COMMUNICATE_CORE_CLOSE,
  // TODO: should consider different modes?
  ({ meta }) => wapprunnerRemove(meta),
  true,
)

// wappSub.subscribe(
//   WAPP_COMMUNICATE_HOOK_ON_CUSTOMIZATION_DONE,
//   // TODO: sendWappPanel wappRunner reset!
//   ({ payload, meta: { wappId } }) =>
//     payload.customize && resolveCustomizationWith(wappId, payload.customize),
//   true,
// )
